var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEscalate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2400517_analysis_analytics_inflation_report_statistics_icon",
    "data-name": "2400517_analysis_analytics_inflation_report_statistics_icon",
    transform: "translate(-6.275 -6.275)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(6.275 6.275)",
    fill: "#21b81c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reload",
    d: "M17.436,4.343l-1.051.822a7.827,7.827,0,1,0,1.189,7.5.15.15,0,0,0-.091-.192l-1.057-.363a.149.149,0,0,0-.188.089c-.034.093-.071.186-.11.278a6.413,6.413,0,1,1-.856-6.446L14.15,6.91a.149.149,0,0,0,.056.263l3.273.8a.15.15,0,0,0,.185-.144l.015-3.372A.15.15,0,0,0,17.436,4.343Z",
    transform: "translate(15.241 15.29)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalate);
export default __webpack_public_path__ + "static/media/escalate.ea005f5fdeb2d1f887cebed68208555f.svg";
export { ForwardRef as ReactComponent };